import { __read, __spread, __values } from "tslib";
import { getGlobalAmplitudeNamespace, logger } from '@amplitude/utils';
import { DEFAULT_IDENTITY_INSTANCE } from '@amplitude/types';
import { DefaultIdentity } from './identity';
var IdentityManager = /** @class */ (function () {
    function IdentityManager() {
        this._instanceMap = new Map();
    }
    IdentityManager.prototype.getInstance = function (instanceName, optionalFallbackIdentity) {
        if (instanceName === void 0) { instanceName = DEFAULT_IDENTITY_INSTANCE; }
        if (optionalFallbackIdentity === void 0) { optionalFallbackIdentity = null; }
        var identity = this._instanceMap.get(instanceName);
        if (identity === undefined) {
            identity = optionalFallbackIdentity !== null ? optionalFallbackIdentity : new DefaultIdentity();
            this._instanceMap.set(instanceName, identity);
        }
        return identity;
    };
    /**
     *  Resets an instance's identity.
     *  Warning: Use only if you are sure that future events should not be attributed to the same user.
     *  Previous user properties will be lost. New events will not appear in a the original user stream.
     */
    IdentityManager.prototype.resetInstance = function (instanceName, optionalNewIdentity) {
        var e_1, _a;
        var _b;
        if (instanceName === void 0) { instanceName = DEFAULT_IDENTITY_INSTANCE; }
        if (optionalNewIdentity === void 0) { optionalNewIdentity = null; }
        var oldIdentity = this._instanceMap.get(instanceName);
        var oldListeners = (_b = oldIdentity === null || oldIdentity === void 0 ? void 0 : oldIdentity.getIdentityListeners()) !== null && _b !== void 0 ? _b : [];
        if (oldIdentity === undefined) {
            logger.warn("Did not find a identity to reset for " + instanceName);
        }
        else {
            this._instanceMap.delete(instanceName);
        }
        var newIdentity;
        if (optionalNewIdentity !== null) {
            newIdentity = optionalNewIdentity;
        }
        else {
            newIdentity = new DefaultIdentity();
            newIdentity.initializeDeviceId();
        }
        this._instanceMap.set(instanceName, newIdentity);
        if (oldListeners.length > 0) {
            try {
                // Actively call the old listeners for the new identity
                for (var oldListeners_1 = __values(oldListeners), oldListeners_1_1 = oldListeners_1.next(); !oldListeners_1_1.done; oldListeners_1_1 = oldListeners_1.next()) {
                    var listener = oldListeners_1_1.value;
                    listener(newIdentity.getDeviceId(), newIdentity.getUserId());
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (oldListeners_1_1 && !oldListeners_1_1.done && (_a = oldListeners_1.return)) _a.call(oldListeners_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            // Add the old listeners
            newIdentity.addIdentityListener.apply(newIdentity, __spread(oldListeners));
        }
    };
    return IdentityManager;
}());
var globalNamespace = getGlobalAmplitudeNamespace();
var identityManager = globalNamespace.identityManager;
if (identityManager === undefined) {
    identityManager = new IdentityManager();
    globalNamespace.identityManager = identityManager;
}
export { identityManager };
//# sourceMappingURL=identityManager.js.map